import { IGarageActionTypes } from "action/interfaces/garage.interface";
import { VehicleSelectionOption } from "api/interfaces/garage-apis";
import { IVehcileDefaultValues, IVehicle } from "interfaces/session/IVehicle";
import { defaultVehicleImageSrc } from "util/helper/getDefaultVehicleImage";
import { deepEqual } from "util/lodash/deepEqual";
import { equalVehicles } from "util/vehicle/equal-vehicles";

export interface GarageState {
  selectedVehicle: IVehicle | null,
  vehicles: IVehicle[]
}
export interface IGarageReducer extends GarageState {
  isLoading: boolean;
  isCompleteVehicleSelected: boolean;
  defaultValues: IVehcileDefaultValues,
  vehicleImageUrl: string;
  vehicleSelectionOptions: {
    vehicleSelectionOptions: VehicleSelectionOption[];
    nextVehicleSelectionOption: string;
    vehicleSelectionOptionType: string;
  }
  vehicleImages: {
    small: string;
    medium: string;
    large: string;
    angle?: string;
  };
  vehicleAnnotations: any;
}

const defaultImage = defaultVehicleImageSrc;

export const initialState: IGarageReducer = {
  isLoading: true,
  selectedVehicle: null,
  isCompleteVehicleSelected: false,
  vehicleImageUrl: defaultImage,
  vehicleImages: {
    small: defaultImage,
    medium: defaultImage,
    large: defaultImage,
  },
  vehicles: [],
  defaultValues: {
    defaultMake: null,
    defaultModel: null,
    defaultYear: null,
    displayableMake: null,
    displayableModel: null,
  },
  vehicleSelectionOptions: {
    vehicleSelectionOptions: [],
    nextVehicleSelectionOption: "",
    vehicleSelectionOptionType: "",
  },
  vehicleAnnotations: null,
};

const garageReducer = (state = initialState, action: IGarageActionTypes) => {
  switch (action.type) {
  case "SELECT_VEHICLE":
    if (!deepEqual(action.data, state.selectedVehicle)) {
      const updatedVehicles = [...state.vehicles];
      if (action.data) {
        // update the garage vehicles list
        const existingIndex = updatedVehicles.findIndex((item) => equalVehicles(action.data, item));
        if (existingIndex !== -1) {
          updatedVehicles.splice(existingIndex, 1);
        }
        updatedVehicles.unshift(action.data);
      }

      return {
        ...state,
        selectedVehicle: action.data ? { ...action.data } : null,
        vehicles: updatedVehicles,
      };
    }
    return {
      ...state,
    };

  case "REMOVE_VEHICLE": {
    const { selectedVehicle } = state;
    if (equalVehicles(action.data, selectedVehicle)) {
      return {
        ...state,
        selectedVehicle: null,
      };
    }

    return state;
  }

  case "SET_GARAGE": {
    if (!deepEqual(action.data.selectedVehicle, state.selectedVehicle)
        || !deepEqual(action.data.vehicles, state.vehicles)
    ) {
      return {
        ...state,
        isLoading: false,
        selectedVehicle: action.data.selectedVehicle ? { ...action.data.selectedVehicle } : null,
        vehicles: [...action.data.vehicles],
      };
    }
    return {
      ...state,
      isLoading: false,
    };
  }

  case "GET_ALL_VEHICLES": {
    return {
      ...state,
      vehicles: [...action.data],
    };
  }

  case "SET_DEFAULT_MAKE_MODEL": {
    return {
      ...state,
      defaultValues: { ...action.data },
    };
  }

  case "SET_COMPLETE_VEHICLE_SELECTED": {
    return {
      ...state,
      isCompleteVehicleSelected: action.data,
    };
  }
  case "SET_VEHICLE_IMAGE_URL": {
    return state.vehicleImageUrl === action.data
      ? state
      : { ...state, vehicleImageUrl: action.data };
  }
  case "SET_VEHICLE_ANNOTATIONS": {
    return {
      ...state,
      vehicleAnnotations: action.data,
    };
  }
  case "SET_VEHICLE_IMAGES": {
    return {
      ...state,
      vehicleImages: action.data,
    };
  }
  case "SET_VEHICLE_FROM_GET_PAGE_DETAILS": {
    return {
      ...state,
      vehicleSelectionOptions: { ...action.data },
    };
  }
  default:
    return state;
  }
};

export default garageReducer;
